import {Col, Row} from "react-bootstrap";
import React from "react";
import {
    getECCategoryOptions,
    getECTypeOptions,
    getICCategoryOptions,
    getICTypeOptions
} from "../../../_helpers/sharedmydata";
import Button from "react-bootstrap/Button";
import {useSelector} from "react-redux";
import {handleSaveMyDataClassifications, isEmpty} from "../../../_helpers/commonFunctions";
import {toast} from "react-toastify";

const ClassificationsDifferencesTable = ({reportType, classificationsRowData, successfullCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const icCategory = getICCategoryOptions();
    const ecCategory = getECCategoryOptions();
    const allCategories = [...icCategory, ...ecCategory];
    const icType = getICTypeOptions(true);
    const ecType = getECTypeOptions(true);
    const allTypes = [...icType, ...ecType];

    const handleSave = async () => {
        const response = await handleSaveMyDataClassifications(classificationsRowData, company.id, reportType);
        if (response.status === "200") {
            successfullCallback();
            return toast.success("Επιτυχής αποθήκευση.");
        } else {
            return toast.error(response.message);
        }
    }

    const alignTables = (leftArray, rightArray) => {
        const BLANK_ROW = {
            classificationCategory: "",
            classificationType: "",
            classificationValue: 0,
            difference: false,
            blank: true,
        }

        // Convert both arrays into maps for quick lookup
        const leftMap = new Map(leftArray.map(item => [item.classificationType, item]));
        const rightMap = new Map(rightArray.map(item => [item.classificationType, item]));

        // Create a sorted union of all unique classificationTypes
        const allTypes = Array.from(new Set([
            ...leftArray.map(item => item.classificationType),
            ...rightArray.map(item => item.classificationType),
        ])).sort();

        // Prepare aligned output
        const alignedLeft = [];
        const alignedRight = [];

        for (const type of allTypes) {
            const leftItem = leftMap.get(type);
            const rightItem = rightMap.get(type);

            alignedLeft.push(leftItem || { ...BLANK_ROW, classificationType: type });
            alignedRight.push(rightItem || { ...BLANK_ROW, classificationType: type });
        }

        return [alignedLeft, alignedRight];
    }

    const getClassificationDifferences = () => {
        const arrERP = [];
        const arrMD = [];
        if (classificationsRowData && classificationsRowData?.classified === "true") {
            const row = classificationsRowData;
            const keyName = row?.sentClassifications ? "sentClassifications" : "classifications";
            if (row[keyName]?.length > 0 && row.myDataClassifications?.length > 0) {
                for (let classi of row[keyName]) {
                    const findMatch = arrERP.find((el) => el.classificationCategory === classi.classificationCategory
                        && (
                            el.classificationType === classi.classificationType
                            || (el.classificationType === "null" && isEmpty(classi.classificationType))
                            || (isEmpty(el.classificationType) && classi.classificationType === "")
                        )
                    );
                    let am;
                    if (keyName === "sentClassifications") {
                        am = +classi.classificationValue;
                    } else {
                        const base = +classi.netPrice;
                        am = +Number((classi.vatExpenseType || reportType === "sales") ? base : base + +classi.vatAmount).toFixed(2);
                    }
                    if (findMatch) {
                        findMatch.classificationValue += am;
                        findMatch.classificationValue = +Number(findMatch.classificationValue).toFixed(2);
                    } else {
                        arrERP.push({
                            classificationCategory: classi.classificationCategory,
                            classificationType: classi.classificationType,
                            classificationValue: am,
                        })
                    }
                }

                for (let md of row.myDataClassifications) {
                    const findMatch = arrERP.find((el) => el.classificationCategory === md.classificationCategory
                        && (
                            el.classificationType === md.classificationType
                            || (el.classificationType === "null" && isEmpty(md.classificationType))
                            || (isEmpty(el.classificationType) && md.classificationType === "")
                        )
                    );
                    const absClassificationValue = Math.abs(md?.classificationValue) || 0;
                    const diff = findMatch ? Math.abs(+Number(findMatch?.classificationValue - absClassificationValue).toFixed(2)) : absClassificationValue;
                    if (!findMatch || diff !== 0) {
                        arrMD.push({...md, classificationValue: absClassificationValue, difference: true, amountDifference: diff});
                    } else {
                        arrMD.push({...md, classificationValue: absClassificationValue});
                    }
                }

                for (let classi of arrERP) {
                    const findMatch = arrMD.find((el) => el.classificationCategory === classi.classificationCategory
                        && (
                            el.classificationType === classi.classificationType
                            || (el.classificationType === "null" && isEmpty(classi.classificationType))
                            || (isEmpty(el.classificationType) && classi.classificationType === "")
                        )
                    );
                    const diff = findMatch ? Math.abs(+Number(findMatch?.classificationValue - classi?.classificationValue).toFixed(2)) : classi.classificationValue;
                    if (!findMatch || diff !== 0) {
                        classi.difference = true;
                        classi.amountDifference = diff;
                    }
                }
            }
        }

        arrERP.sort((a, b) => {
            const categoryComparison = String(a.classificationCategory).localeCompare(b.classificationCategory);
            if (categoryComparison !== 0) return categoryComparison;

            return String(a.classificationType).localeCompare(b.classificationType);
        })

        arrMD.sort((a, b) => {
            const categoryComparison = String(a.classificationCategory).localeCompare(b.classificationCategory);
            if (categoryComparison !== 0) return categoryComparison;

            return String(a.classificationType).localeCompare(b.classificationType);
        })

        return alignTables(arrERP, arrMD);
    }

    const renderDifferencesComponent = () => {
        const resp = getClassificationDifferences();
        const arrERP = resp[0];
        const arrMD = resp[1];
        if (arrERP.length > 0 && arrMD.length > 0) {
            return (
                <React.Fragment>
                    <Row className={"border-top mt-2 pt-2"}>
                        <Col md={6}>
                            <div style={{textAlign: "center"}} className={"mb-1"}><h6>Χαρακτηρισμοί ERP</h6></div>
                            <table className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "40%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Κατηγορία MyData</th>
                                    <th>Τύπος MyData</th>
                                    <th>Συνολικό ποσό χαρακτηρισμού</th>
                                    <th>Κατάσταση</th>
                                </tr>
                                </thead>
                                <tbody>
                                {arrERP.map((row, idx) => {
                                    if (row.blank) {
                                        return (
                                            <tr key={`diffClass-${idx}`}>
                                                <td>&nbsp;<br/>&nbsp;</td>
                                                <td>&nbsp;<br/>&nbsp;</td>
                                                <td>&nbsp;<br/>&nbsp;</td>
                                                <td>&nbsp;<br/>&nbsp;</td>
                                            </tr>
                                        )
                                    } else {
                                        return (
                                            <tr key={`diffClass-${idx}`} style={{backgroundColor: row.difference ? "lightyellow" : "#bffcbd"}}>
                                                <td>{allCategories.find((el) => el.value === row.classificationCategory)?.label}</td>
                                                <td>{allTypes.find((el) => el.value === row.classificationType)?.label}</td>
                                                <td>{row.classificationValue}</td>
                                                <td>{row.difference ? `Ασυμφωνία: ${row.amountDifference}` : "Συμφωνία"}</td>
                                            </tr>
                                        )
                                    }
                                })}
                                </tbody>
                            </table>
                        </Col>
                        <Col md={6}>
                            <div style={{textAlign: "center"}} className={"mb-1"}><h6>Χαρακτηρισμοί MyData</h6></div>
                            <table className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "40%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Κατηγορία MyData</th>
                                    <th>Τύπος MyData</th>
                                    <th>Συνολικό ποσό χαρακτηρισμού</th>
                                    <th>Κατάσταση</th>
                                </tr>
                                </thead>
                                <tbody>
                                {arrMD.map((row, idx) => {
                                    if (row.blank) {
                                        return (
                                            <tr key={`diffClass-${idx}`}>
                                                <td>&nbsp;<br/>&nbsp;</td>
                                                <td>&nbsp;<br/>&nbsp;</td>
                                                <td>&nbsp;<br/>&nbsp;</td>
                                                <td>&nbsp;<br/>&nbsp;</td>
                                            </tr>
                                        )
                                    } else {
                                        return (
                                            <tr key={`diffClass-${idx}`}
                                                style={{backgroundColor: row.difference ? "lightyellow" : "#bffcbd"}}>
                                                <td>{allCategories.find((el) => el.value === row.classificationCategory)?.label}</td>
                                                <td>{allTypes.find((el) => el.value === row.classificationType)?.label}</td>
                                                <td>{row.classificationValue}</td>
                                                <td>{row.difference ? `Ασυμφωνία: ${row.amountDifference}` : "Συμφωνία"}</td>
                                            </tr>
                                        )
                                    }
                                })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    {arrERP.some((el) => el.difference) && (
                        <div className={"mt-2"} style={{textAlign: "right"}}>
                            <Button onClick={() => handleSave()}>Αποθήκευση των χαρακτηρισμών του MyData</Button>
                        </div>
                    )}
                </React.Fragment>
            )
        }
        return <React.Fragment></React.Fragment>
    }

    return (
        <React.Fragment>
            {renderDifferencesComponent()}
        </React.Fragment>
    )
}

export default ClassificationsDifferencesTable
